import Data from '../../../components/Backoffice/Display/Data';
import DataTag from '../../../components/Backoffice/Display/DataTag';
import MultipleDataTag from '../../../components/Backoffice/Display/MultipleDataTag';
import Section from '../../../components/Backoffice/Display/Section';
import SubSection from '../../../components/Backoffice/Display/SubSection';
import UrlCard from '../../../components/Backoffice/Display/UrlCard';
import { getConstant } from '../../../utils/constants';
import { formatDateString } from '../../../utils/stringHelper';

function ResidencyInformation({ residency, handleResidencyUpdate, loading }) {
  const updateResidencyAction = {
    onClick: handleResidencyUpdate,
    label: 'Modifier les informations',
    icon: 'pi-pencil',
    loading
  };

  return (
    <Section label="Informations générales" actions={[updateResidencyAction]} showDivider={false}>
      {/* Informations */}
      <div className="data-section-row">
        <Data key="label" label={'Nom'} value={residency.label} large />
        <Data
          key="projectDeveloper"
          label={'Porteur.euse de projet'}
          value={residency.project_developer}
          large
        />

        <MultipleDataTag
          key="tags"
          label={'Tags'}
          tags={residency.properties.map((property) => ({
            label: property.label
          }))}
          rounded
        />
      </div>
      <div className="data-section-row">
        <DataTag
          key="type"
          label={'Type'}
          tag={getConstant('backoffice.residency.typeList', residency.type)}
          rounded
          large
        />
        <DataTag
          key="state"
          label={'État'}
          tag={getConstant('backoffice.residency.stateList', residency.state)}
          rounded
          large
        />
        <Data
          key="rooms"
          label={'Salles'}
          value={residency.rooms.map((r) => r.label).join(' & ')}
          large
        />
      </div>
      <div className="data-section-row">
        <Data
          key="startDate"
          label={'Date de début'}
          value={formatDateString(residency.start_dt)}
          large
        />
        <Data
          key="endDate"
          label={'Date de fin'}
          value={formatDateString(residency.end_dt)}
          large
        />
        <Data key="email" label={'Adresse email'} value={residency.email} large />
      </div>

      <SubSection label="Mes liens externes">
        {residency.urls.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {residency.urls?.map((url) => (
              <UrlCard url={url} key={url.id} />
            ))}
          </div>
        ) : (
          <div className="empty-section-message">Aucun lien</div>
        )}
      </SubSection>

      <div className="grid grid-cols-2 gap-5">
        <SubSection label="Ma description">
          <p
            className="description-residency"
            dangerouslySetInnerHTML={{ __html: residency.description }}></p>
        </SubSection>
        <SubSection label="Qu'est ce que je viens faire à Pasteur ?">
          <p dangerouslySetInnerHTML={{ __html: residency.motivation }}></p>
        </SubSection>
      </div>
    </Section>
  );
}

export default ResidencyInformation;
